import React from "react";

import {
  Content,
  Card,
  Notificacao,
  BannerContainer,
} from "./styles";
import { Container } from "../../../styles/GlobalStyles";

import Header from "../../../components/Header";
import { useState } from "react";
import { useEffect } from "react";
import { api } from "../../../services/api";
import { useHistory } from "react-router-dom";
import { getUsuario } from "../../../services/security";

function Home() {
  const history = useHistory();
  const headerLinks = [{ label: "Sair", to: "/" }];

  const [notificacoes, setNotificacoes] = useState([]);

  const [mostrarContent, setMostrarContent] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setMostrarContent(true);
    }, 1500);

    const listarNotificacoes = async () => {
      try {
        const response = await api.get("/empresas/notificacoes");

        setNotificacoes(response.data);
      } catch (e) {
        console.log(e);
      }
    };

    listarNotificacoes();
  }, []);

  const irParaVaga = async (notificacao) => {
    try {
      history.push(`/empresa/detalhe-vaga/${notificacao.vaga_id}`);

      api.post(`/empresas/notificacoes/${notificacao.id}/visto`);
    } catch (e) {
      console.log(e);
    }
  };

  const marcarNotificacaoComoVisto = (notificacaoId) => {
    api.post(`/empresas/notificacoes/${notificacaoId}/visto`);

    setNotificacoes((anterior) =>
      anterior.filter((n) => n.id !== notificacaoId)
    );
  };

  return (
    <Container>
      <Header links={headerLinks} theme="black" />
      <Content>
        <h1>Olá, {getUsuario().nome_contato}, bom te ver por aqui!</h1>

        {/* <DashContainer>
          <Card>
            <h1>Vagas Abertas</h1>
          </Card>
          <Card></Card>
        </DashContainer> */}
        {mostrarContent && (
          <>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <BannerContainer>
                  <p id="teste">Os melhores profissionais</p>
                  <p id="2">Passam pelo SENAI</p>
                  <p id="3">Compartilhe uma oportunidade aqui!</p>
                  <button
                    style={{
                      width: "50%",
                      alignSelf: "center",
                    }}
                    onClick={() => history.push("/empresa/nova-vaga")}
                  >
                    Abrir Vaga
                  </button>
              </BannerContainer>
            </div>
            <Card>
              <h1>Últimas atualizações</h1>
              {notificacoes.length === 0
                ? "Por agora, nada de novo."
                : notificacoes.map((n) => (
                    <Notificacao key={n.id}>
                      <section onClick={() => irParaVaga(n)}>
                        <h1>{n.titulo}</h1>
                        <p>{n.descricao}</p>
                      </section>
                      <span onClick={() => marcarNotificacaoComoVisto(n.id)}>
                        &times;
                      </span>
                    </Notificacao>
                  ))}
              {}
            </Card>
          </>
        )}
      </Content>
    </Container>
  );
}

export default Home;
